import { createReducer, on } from "@ngrx/store";
import {
  loadResults,
  loadResultsSuccess,
  setCollectionName,
  setSearchResultPage,
  setSearchTerm, setSelectedFilters,
  updateTotalMatching
} from "./search.actions";

// this interface is here to avoid TS error when using a string to access object keys
// this error would have appeared in the text block when dynamically loading the content area layout
interface IObjectKeys {
  [key: string]: any;
}

export interface SearchState extends IObjectKeys {
  searchResults: any;
  totalMatching: number;
  trackingId: string;
  searchTerm: string;
  loading: boolean;
  searchResultPage: string;
  collectionName: string;
  searchFilters: any,
  selectedFilters: any
}

export const initialState: SearchState = {
  searchResults: null,
  totalMatching: 0,
  trackingId: "",
  searchTerm: "",
  loading: false,
  searchResultPage: "",
  collectionName: "",
  searchFilters: {},
  selectedFilters: {}
};

export const searchReducer = createReducer(
  initialState,
  on(loadResults, (state) => {
    return {
      ...state,
      loading: true
    };
  }),
  on(loadResultsSuccess, (state, { search, searchTerm, collection, page, filters }) => {
    const body = search?.body || {};
    return {
      ...state,
      searchResults: body.results || [],
      totalMatching: body.totalMatching || 0,
      trackingId: body.trackingId || '',
      searchTerm: searchTerm,
      collection: collection,
      page: page,
      loading: false,
      searchFilters: filters
    };
  }),
  on(setSearchTerm, (state, { searchTerm }) => {
    return {
      ...state,
      searchTerm: searchTerm
    };
  }),
  on(setSearchResultPage, (state, { searchResultPage }) => {
    return {
      ...state,
      searchResultPage: searchResultPage
    };
  }),
  on(setCollectionName, (state, { collectionName }) => {
    return {
      ...state,
      collectionName: collectionName
    };
  }),
  on(updateTotalMatching, (state, { total }) => ({
    ...state,
    totalMatching: total
  })),
  on(setSelectedFilters, (state, { selectedFilters }) => {
    return {
      ...state,
      selectedFilters: selectedFilters
    };
  }),
);
